import { Plus } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useLanguage } from "@/context/LanguageContext";
import { carTestLabels } from "@/i18n/labels";
import {
  ColoredOutlineButton,
  OUTLINE_TEXT_BUTTON_ICON_CLASS,
} from "@/components/ui/colored-outline-button";
import { cn } from "@/lib/utils";

interface CreateTestButtonProps {
  onClick: () => void;
  className?: string;
  wrapperClassName?: string;
}

const CreateTestButton = ({
  onClick,
  className = "",
  wrapperClassName = "",
}: CreateTestButtonProps) => {
  const { language } = useLanguage();
  const ct = carTestLabels(language);
  const isMobile = useIsMobile();

  const label = isMobile
    ? ((ct.actions as Record<string, string>).createShort ?? "Ny")
    : ct.actions.create;

  return (
    <ColoredOutlineButton
      type="button"
      variant="gold"
      tintedBackground
      size="sm"
      onClick={onClick}
      className={cn(
        "px-2.5 h-8 flex-shrink-0 text-xs gap-1.5",
        className,
        wrapperClassName,
      )}
    >
      <Plus className={OUTLINE_TEXT_BUTTON_ICON_CLASS} strokeWidth={2.35} />
      <span>{label}</span>
    </ColoredOutlineButton>
  );
};

export default CreateTestButton;
